import React from 'react';
import { useIntl } from 'react-intl';
import { Link } from 'react-router-dom';

interface MyLinkProps extends React.AnchorHTMLAttributes<HTMLAnchorElement> {
  href: string;
  useATag?: boolean;
}

const MyLink: React.FC<MyLinkProps> = ({
  href,
  children,
  useATag,
  ...props
}) => {
  const { locale } = useIntl();
  let calculatedLink = href;
  const langCheck = /\/..\//g;
  if (!href?.match(langCheck) && href?.startsWith('/')) {
    calculatedLink = `/${locale}${href}`;
  }
  console.log('MyLink', {href, calculatedLink, useATag});
  if (!useATag) {
    return (
      <Link {...props} to={calculatedLink}>{children}</Link>
    );
  }
  return (
    <a {...props} href={calculatedLink}>{children}</a>
  );
};

export default MyLink;
